/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faPrint } from '@fortawesome/pro-duotone-svg-icons';
import { faArrowRotateLeft, faFileAlt } from '@fortawesome/pro-solid-svg-icons';

// Actions
import { updateEnrollment } from '../../../../../actions/enrollment';

// Components
import EditHistory from './EditHistory';
import { LoaderButton } from '../../../../../common/components/index.js';

// Utilities
import { formatOEC } from '../../../../../utils/enroll';

function EditField({ data = {} }) {
  const { field, label, value, onChange } = data;
  return (
    <div className="d-flex flex-column m-2">
      <div className="">{label}</div>
      <div className="d-flex">
        <input
          className="form-control"
          value={value}
          id={field}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
}

function ButtonText({ text, icon }) {
  return (
    <>
      <FontAwesomeIcon className="me-2" icon={icon} />
      {text}
    </>
  );
}

function Error({ text }) {
  return (
    <div className="text-danger">
      {text}
    </div>
  );
}

function Message({ text }) {
  return (
    <div className="text-success">
      {text}
    </div>
  );
}

function Edit({
  enrollment = {},
  agent = {},
  id,
  className,
  style,
}) {
  const {
    carrier,
    quote_id,
    confirmation_number,
    fields: oldFields = {},
  } = enrollment;

  const {
    first_name, last_name,
    email,
    pcp_num,
    home_phone,
    medicare_id,
    plan = {},
  } = oldFields;

  const {
    theme,
  } = useSelector(store => store);

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showHistory, setShowHistory] = useState(false);

  const [newFirstName, setNewFirstName] = useState('');
  const [newLastName, setNewLastName] = useState('');
  const [newPhone, setNewPhone] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [newPcpID, setNewPcpID] = useState('');
  const [newMedicareID, setNewMedicareID] = useState('');

  const dispatch = useDispatch();

  function setEditableFields() {
    setNewFirstName(first_name);
    setNewLastName(last_name);
    setNewPhone(home_phone);
    setNewEmail(email);
    setNewPcpID(pcp_num);
    setNewMedicareID(medicare_id);
  }

  useEffect(() => {
    if (oldFields && Object.keys(oldFields)) {
      setEditableFields();
    }
  }, [oldFields]);

  function handleUndo() {
    setEditableFields();
  }

  function handleSubmit(e) {
    setLoading(true);

    // Reduce our array of fields into an object for posting
    const newFieldsObject = newFields.reduce((acc, f) => {
      return {
        ...acc,
        [f.field]: f.value,
      };
    }, { ...oldFields });

    // Recursive mmb-api diffing exceptions:
    // * Molina has an empty string { col val } and the recursive python diff function breaks..
    //   it looks like there's stuff being done on the backend, where an empty string is set to "Filler N"..?
    //   but it also breaks for uhc and aetna plans in the same fashion.. so maybe it's not a molina-only thing..

    // frontend exceptions
    // * theme.humanaPartnerInfo is undefined for humana plans
    let newSubmittedArray = [];
    try {
      const { formattedData } = formatOEC(carrier, {
        agent,
        quote: {},
        fields: newFieldsObject,
        plan,
        theme,
        confirmationNumber: confirmation_number,
      });
      newSubmittedArray = formattedData;
    } catch {
      setError('There was an issue with carrier formatting');
      setLoading(false);
      return;
    }

    updateEnrollment({
      quote_id,
      fields: newFieldsObject,
      submitted: newSubmittedArray,
    }).then((data) => {
      setMessage('Enrollment successfully updated');
      setError('');
      // Make sure to update the store so the parent index/Table's values are updated too.
      dispatch({ type: 'SET_ENROLLMENT', payload: data });
    }).catch((err = {}) => {
      const { message } = err;
      console.error(message);
      setError('There was a problem updating the enrollment.');
    }).finally(() => {
      setLoading(false);
    });
  }

  const newFields = [
    { field: 'first_name', label: 'First name', value: newFirstName, onChange: setNewFirstName },
    { field: 'last_name', label: 'Last name', value: newLastName, onChange: setNewLastName },
    { field: 'phone', label: 'Phone', value: newPhone, onChange: setNewPhone },
    { field: 'email', label: 'Email', value: newEmail, onChange: setNewEmail },
    { field: 'pcp_id', label: 'PCP ID', value: newPcpID, onChange: setNewPcpID},
    { field: 'medicare_id', label: 'MBI (Medicare ID)', value: newMedicareID, onChange: setNewMedicareID },
  ];

  return (
    <div className="d-flex flex-column d-print-none w-50 m-3 mt-1 pb-3">
      <div className="fw-bold fs-4">Edit Enrollment</div>

      <div className="d-flex w-75">
        <div className="d-flex flex-column w-50">
          {newFields.slice(0, 3).map(f => <EditField key={f.field} data={f} />)}
        </div>
        <div className="d-flex flex-column w-50">
          {newFields.slice(3, 6).map(f => <EditField key={f.field} data={f} />)}
        </div>
      </div>
      <div className="d-flex w-75 mt-3 mb-3">
        <LoaderButton
          className="btn btn-secondary w-25 me-1"
          text={<ButtonText text="Show history" icon={faArrowRotateLeft} />}
          disabled={false}
          onClick={() => setShowHistory(!showHistory)}
        />
        <LoaderButton
          className="btn btn-primary text-white w-25 ms-1"
          loading={loading}
          text={<ButtonText text="Save" icon={faFileAlt} />}
          loadingText={<ButtonText text="Saving.." icon={faFileAlt} />}
          onClick={handleSubmit}          
        />
      </div>
      <Message text={message} />
      <Error text={error} />

      <div className={`${showHistory ? 'd-flex' : 'd-none'} flex-column w-100`}>
        <div className="fw-bold fs-4">Edit History</div>
        <EditHistory enrollment={enrollment} />
      </div>
    </div>
  );
}
export default Edit;
